<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="categoria-evento" titulo="Categoría / Eventos" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>


<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">

            <!-- formulario -->
            <form name="form" novalidate [formGroup]="dato" (ngSubmit)="ctrl.enviar()">
                <section class="hero is-primary">
                    <div class="hero-body">

                        <!-- Opciones  -->
                        <app-formulario-opciones [ctrl]="ctrl" [id]="ctrl.dato.id"></app-formulario-opciones>
                    </div>
                </section>

                <section class="section" style="overflow: auto;padding: 1rem !important;height: 85.8vh;">
                    <div class="columns">
                        <div class="column is-12">
                            <div class="field">
                                <label class="label">Nombre:</label>
                                <p class="control has-icons-left has-icons-right">
                                    <input class="input" autofocus type="text" [ngClass]="{'is-danger': ctrl.dato.get('nombre').hasError('required') }" placeholder="Nombre"
                                        formControlName="nombre">
                                    <span class="icon is-small is-right" *ngIf="ctrl.dato.get('nombre').hasError('required') ">
                                        <i class="fa fa-warning"></i>
                                    </span>
                                    <span class="help is-danger" *ngIf="ctrl.dato.get('nombre').hasError('required') ">Este campo es requerido.</span>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="columns">
                      <div class="column is-12">
                        <div class="field">
                            <label class="label">Imagen:</label>
                            <div class="control has-icons-left has-icons-right" *ngIf="ctrl.dato.get('imagen').value == ''">
                                <div class="file has-name">
                                    <label class="file-label">
                                        <input type="file" class="file-input" (change)="ctrl.seleccionarImagenBase64($event, ctrl.dato.controls.imagen)" accept="image/x-png,image/gif,image/jpeg,image/jpg">
                                        <input foto type="hidden" formControlName="imagen">
                                        <span class="file-cta">
                                            <span class="file-icon">
                                                <i class="fa fa-upload"></i>
                                            </span>
                                            <span class="file-label">
                                                Seleccionar archivo
                                            </span>
                                        </span>

                                    </label>
                                </div>
                            </div>
                            <button type="button" class="button is-danger" (click)="ctrl.borrarImagen($event, ctrl.dato.controls.imagen, 'categoria')"
                                *ngIf="ctrl.dato.get('imagen').value != ''">

                                <span class="icon ">
                                    <i class="icon-trash"></i>
                                </span>
                                &nbsp; Eliminar la imagen
                            </button>

                            <button type="button" class="button is-success" *ngIf="ctrl.dato.controls.imagen.value != ''" (click)="ctrl.abrirModal('verFoto')">
                                <span class="icon">
                                    <i class="icon-eye2"> </i>
                                </span>
                                &nbsp; Ver Foto
                            </button>
                        </div>
                      </div>
                    </div>

                    <div class="columns">
                      <div class="column is-12">
                        <div class="field">
                          <label class="label">Descripción</label>
                          <ckeditor formControlName="descripcion" debounce="500" [config]="CkeditorConfig"></ckeditor>
                        </div>
                      </div>
                    </div>

                </section>
            </form>
        </div>
    </div>
</div>


<div class="modal" id="verFoto">
    <div class="modal-background"></div>
    <div class="modal-content">
        <p class="image is-4by3">
            <img *ngIf="!ctrl.subir[0]" [src]="ctrl.API_PATH+'/adjunto/evento/'+ctrl.dato.get('imagen').value" alt="Foto" />
            <img *ngIf="ctrl.subir[0]" [src]="'data:image/jpg;base64,'+ctrl.dato.get('imagen').value" alt="Foto" />
        </p>
    </div>
    <button type="button" class="modal-close" (click)="ctrl.cancelarModal('verFoto')"></button>
</div>
